import Icon from '../components/Icon.vue'

Icon.register({
  'file-medical': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M377 105c4.5 4.5 7 10.6 7 16.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7zM224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM288 296c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-medical.js
// module id = 1341
// module chunks = 0